import React from 'react';
// import { Swiper, SwiperSlide } from "swiper";
import { Swiper } from "swiper/react/swiper"
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";

import ProjectItem from './PortfolioItem';

import mitsui from '../assets/img/mitsui.png';
import kaneda from '../assets/img/kaneda.png';
import covid from '../assets/img/covid.png';
import digital from '../assets/img/digital.png';
import buy from '../assets/img/buy.png';
import toonyfy from '../assets/img/toonyfy.png';
import radient from '../assets/img/radient.png';
import { SwiperSlide } from 'swiper/react/swiper-slide';

const projects = [
    {
        image: mitsui,
        title: 'Mitsuiauto',
        desc: 'HTML, CSS, JQuery, AJAX',
        icon: 'fas fa-link link',
        link: 'https://mitsuiautojp.com/',
        
    },
    {
        image: kaneda,
        title: 'Kaneda Shokai',
        desc: 'Laravel, Bootstrap, JQuery, AJAX',
        icon: 'fas fa-link link',
        link: 'https://kanedashokai.com/',
        
    },
    {
        image: covid,
        title: 'COVID-19 Tracker',
        desc: 'React JS, Bootstrap, REST API',
        icon: 'fas fa-link link',
        link: 'https://mshafnas.github.io/covid-19-tracker/',
        
    },
    {
        image: radient,
        title: 'Radient Traders',
        desc: 'PHP, Bootstrap, JQuery, AJAX',
        icon: 'fas fa-link link',
        link: 'https://radient.com/',
        
    },
    {
        image: digital,
        title: 'Digital Marketing',
        desc: 'HTML5, CSS3, JQuery',
        icon: 'fas fa-link link',
        link: 'https://sldigital.lk/',
        
    },
    {
        image: buy,
        title: 'Buy-U-Coin',
        desc: 'HTML5, CSS3, JQuery',
        icon: 'fas fa-link link',
        link: 'https://buyucoin.com/',
        
    },
    {
        image: toonyfy,
        title: 'Toonofy',
        desc: 'HTML5, CSS3, JQuery',
        icon: 'fas fa-link link',
        link: 'https://toonofy.com/',
        
    }    
];

const Portfolio = () => {
    return (
        <section className="portfolio section" id="portfolio">
            <h2 className="section__title">Portfolio</h2>
            <span className="section__subtitle">Recent works</span>
            <div className="portfolio__container container">
                <Swiper
                    cssMode={true}
                    navigation={true}
                    pagination={true}
                    mousewheel={true}
                    keyboard={true}
                    modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                    className="mySwiper"
                >
                    {
                        projects.map((item, idx) => (
                            <SwiperSlide key={idx} ><ProjectItem value={item} /></SwiperSlide>
                        ))
                    }
                    {/* <SwiperSlide>dsad</SwiperSlide>
                    <SwiperSlide>dsad</SwiperSlide> */}
                </Swiper>

            </div>
        </section>
    )
}

export default Portfolio;